import { walletReducer } from '../reducers/WalletReducer';

export const addWalletInfo = (wallets) => async (dispatch) => {
    dispatch((walletReducer(wallets)));
  };
